var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamic3PackBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.06 360.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a3a3a3;\n      }\n\n      .cls-2 {\n        fill: none;\n        opacity: .5;\n        stroke: #a3a3a3;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 217.82,
    y: 117.84,
    width: 65.42,
    height: 65.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 220.51,
    y: 191.79,
    width: 60.04,
    height: 12.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 233.21,
    y: 208.39,
    width: 34.64,
    height: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 217.82,
    y: 220.62,
    width: 65.42,
    height: 16.82,
    rx: 8.41,
    ry: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 191.13,
    y: 94.36,
    width: 118.8,
    height: 171.67
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361.93,
    y: 117.84,
    width: 65.42,
    height: 65.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.62,
    y: 191.79,
    width: 60.04,
    height: 12.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 377.32,
    y: 208.39,
    width: 34.64,
    height: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361.93,
    y: 220.62,
    width: 65.42,
    height: 16.82,
    rx: 8.41,
    ry: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.24,
    y: 94.36,
    width: 118.8,
    height: 171.67
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.71,
    y: 117.84,
    width: 65.42,
    height: 65.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.41,
    y: 191.79,
    width: 60.04,
    height: 12.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.11,
    y: 208.39,
    width: 34.64,
    height: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.71,
    y: 220.62,
    width: 65.42,
    height: 16.82,
    rx: 8.41,
    ry: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.02,
    y: 94.36,
    width: 118.8,
    height: 171.67
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamic3PackBanner);
export default __webpack_public_path__ + "static/media/dynamic_3pack_banner.eaee482dda3d009fa43a9cf2cd95e319.svg";
export { ForwardRef as ReactComponent };